<style scoped>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
  /* display: none;*/
  -webkit-appearance: none;
  margin: 0; 
  }
</style>
<style scoped>
  .content-wrapper .content{
  padding-top: 95px;
  } 
.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}                                          
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; 
  }
  .el-select{
  display: block;
  }
  .el-button--info {
  box-shadow: 0 1px 7px rgba(0,0,0,.05);
  border: 1px solid rgba(0,0,0,.04)!important;
  padding: 10px;
  background-color: white;
  color:black;
  }
  .el-button--info:hover {
  box-shadow: 0 1px 40px rgba(0,0,0,.05);
  border: 1px solid rgba(0,0,0,.04)!important;
  padding: 10px;
  background-color: white;
  color:black;
  }
  .el-input-group__prepend{
  cursor: pointer;
  }
  button[disabled=disabled], button:disabled {
  background-color: rgba(200,200,200,2.3);
  cursor: not-allowed;
  }
  .m-t-15{
  margin-top: 15px;
  }
</style>
<template>
  <div class="content-wrapper">
    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Change Password</h3>
        </div>
        <div class="box-body">
            <div class="row">
              <div class="col-md-9">
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-sm-offset-4">
                <p v-html="message"></p>
                <div class="form-group">
                  <p>Enter the old password</p>
                  <el-input type="password" placeholder="Old Password" v-model="credentials.oldPassword"></el-input>
                </div>
                <p>Enter the password</p>
                <div class="form-group">
                  <el-input type="password" placeholder="New Password" v-model="credentials.newPassword1"></el-input>
                </div>
                <div class="form-group">
                  <el-input type="password" placeholder="New Password" v-model="credentials.newPassword2"></el-input>
                </div>
                <div>
                  <span>
                    <button class="btn btn-success" @click="passwordChange()">Submit</button>
                  </span>
                  <span>
                  <button class="btn btn-danger" @click="clear()">Clear</button>
                </span>
              </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        credentials: {
          newPassword1: '',
          newPassword2: ''
        },
        message: ''
      }
    },
  
    methods: {
      clear() {
         this.credentials.old_password = '';
         this.credentials.newPassword1 = '';
         this.credentials.newPassword2 = '';
      },
      passwordChange () {
        axios.post(BASE_URL + 'v1/auth/password/change/', {
          old_password:  this.credentials.oldPassword,
          new_password1: this.credentials.newPassword1,
          new_password2: this.credentials.newPassword2
        })
  
        .then(response => {
            this.$notify({
              title: 'Success',
              message: 'Password has been changed successfully.',
              type: 'success'
            });

            setTimeout(() => { this.$router.push('/admin/domains/'); }, 1000);
        })
        .catch(error => {
          if (error.response.status == 400) {
              if(error.response.data['old_password']){
                this.$notify({
                  title: 'Entered User Password Wrong',
                  message: 'Please Enter the correct the password.',
                  type: 'warning'
                });
                this.credentials.old_password = '';
              }
            else {
              this.message = error.response.data.new_password2[0]
                this.$notify({
                  title: 'Unable to Update',
                  message: 'The entered passwords don\'t match.',
                  type: 'warning'
                });
                this.credentials.newPassword1 = '';
                this.credentials.newPassword2 = '';
            }
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ChangePassword.vue?2530818a